import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { INDIVIDUAL_CALENDAR_PATH } from '@app/constants';

import { useCalendarContext } from '@pages/Calendar/context';

import { useExecutorSelectModel } from './useExecutorSelectModel';

export const useExecutorSelect = () => {
  const navigate = useNavigate();
  const { selectedDateMoment, activeWorkdayEmployeeIds } = useCalendarContext();

  const handleOpenIndividualCalendar = useCallback(
    (employeeId: number) => {
      const dateS = selectedDateMoment.format('YYYY-MM-DD');

      navigate(
        `${INDIVIDUAL_CALENDAR_PATH}?employeeId=${employeeId}&dateS=${dateS}`
      );
    },
    [navigate, selectedDateMoment]
  );

  return useExecutorSelectModel({
    mode: 'appointment-journal',
    excludedEmployeeIds: activeWorkdayEmployeeIds,
    shouldSelectExecutorOnAddWorkingDay: false,
    onOpenIndividualCalendar: handleOpenIndividualCalendar,
  });
};
